import { Route } from '@angular/router';
import { ServiceDatatableType } from '@app/src/app/modules/service/classes/default/datatable/service.datatable.type';
import { ServiceCategoryDatatableType } from '@app/src/app/modules/service/classes/category/datatable/service.category.datatable.type';
import { ServiceGuard } from '@app/src/app/modules/service/classes/default/guard/service-guard';
import { DashboardGlobalConfigType } from '@ckmk/angular';
import { ServiceCategoryGuard } from '@app/src/app/modules/service/classes/category/guard/service-category-guard';

export default (config: DashboardGlobalConfigType): Route => ({
  path: 'services',
  providers: [ServiceDatatableType, ServiceCategoryDatatableType],
  children: [
    {
      path: '',
      redirectTo: 'list',
      pathMatch: 'full',
    },
    {
      path: 'list',
      loadComponent: () =>
        import('@app/src/app/modules/service/views/admin/default/service-list/service-list.component').then(
          (m) => m.ServiceListComponent,
        ),
      data: {
        permissions: ['PERMISSION_READ_SERVICE'],
      },
    },
    {
      path: 'show/:service',
      loadComponent: () =>
        import('@app/src/app/modules/service/views/admin/default/service-show/service-show.component').then(
          (m) => m.ServiceShowComponent,
        ),
      data: {
        permissions: ['PERMISSION_READ_SERVICE'],
      },
      canActivate: [ServiceGuard(config)],
    },
    {
      path: 'create',
      loadComponent: () =>
        import('@app/src/app/modules/service/views/admin/default/service-manage/service-manage.component').then(
          (m) => m.ServiceManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_CREATE_SERVICE'],
      },
    },
    {
      path: 'update/:service',
      loadComponent: () =>
        import('@app/src/app/modules/service/views/admin/default/service-manage/service-manage.component').then(
          (m) => m.ServiceManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_UPDATE_SERVICE'],
      },
      canActivate: [ServiceGuard(config)],
    },
    {
      path: 'copy/:service',
      loadComponent: () =>
        import('@app/src/app/modules/service/views/admin/default/service-manage/service-manage.component').then(
          (m) => m.ServiceManageComponent,
        ),
      data: {
        permissions: ['PERMISSION_COPY_SERVICE'],
      },
      canActivate: [ServiceGuard(config)],
    },
    {
      path: 'categories',
      children: [
        {
          path: '',
          redirectTo: 'list',
          pathMatch: 'full',
        },
        {
          path: 'list',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/admin/category/category-list/service-category-list.component').then(
              (m) => m.ServiceCategoryListComponent,
            ),
          data: {
            permissions: ['PERMISSION_READ_SERVICE_CATEGORY'],
          },
        },
        {
          path: 'show/:category',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/admin/category/category-show/service-category-show.component').then(
              (m) => m.ServiceCategoryShowComponent,
            ),
          data: {
            permissions: ['PERMISSION_READ_SERVICE_CATEGORY'],
          },
          canActivate: [ServiceCategoryGuard(config)],
        },
        {
          path: 'create',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/admin/category/category-manage/service-category-manage.component').then(
              (m) => m.ServiceCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_CREATE_SERVICE_CATEGORY'],
          },
        },
        {
          path: 'update/:category',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/admin/category/category-manage/service-category-manage.component').then(
              (m) => m.ServiceCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_UPDATE_SERVICE_CATEGORY'],
          },
          canActivate: [ServiceCategoryGuard(config)],
        },
        {
          path: 'copy/:category',
          loadComponent: () =>
            import('@app/src/app/modules/service/views/admin/category/category-manage/service-category-manage.component').then(
              (m) => m.ServiceCategoryManageComponent,
            ),
          data: {
            permissions: ['PERMISSION_COPY_SERVICE_CATEGORY'],
          },
          canActivate: [ServiceCategoryGuard(config)],
        },
        {
          path: '**',
          redirectTo: 'list',
          pathMatch: 'full',
        },
      ],
    },
    {
      path: '**',
      redirectTo: 'list',
      pathMatch: 'full',
    },
  ],
});
